import { createSelector } from 'reselect'

export const getCart = createSelector(
  (state) => state && state.cart && state.cart.list && Array.isArray(state.cart.list.items) ? state.cart.list.items : [],
  items => items
)
